import { useOutletContext, useParams } from 'react-router-dom';
import { ThreadsView } from '@/components/ThreadsView';
import { useMediaQuery } from '@/lib/useMediaQuery';
import type { ProjectContext } from './ProjectShell';

export function ProjectTalk() {
  const { project } = useOutletContext<ProjectContext>();
  const { threadId } = useParams();
  // Beside the list the general thread is open by default; on a phone the list comes first
  // (otherwise «back» from the general thread would reopen it and the list could never be reached).
  const wide = useMediaQuery('(min-width: 1024px)');
  return <ThreadsView projectId={project.id} selectedId={threadId ?? (wide ? `t-${project.id}` : undefined)} base={`/p/${project.id}/talk`} />;
}
